import React, { useContext, useEffect, useState } from "react";
import { UrlContext } from "../../contexts/UrlContext";

export default function ExistingDigitalBtn({ exp_id, proj_id }) {
  const [showExistingDigital, setShowExistingDigital] = useState(false);
  const [existingDigitalData, setExistingDigitalData] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);
  const { API_URL } = useContext(UrlContext);
  useEffect(() => {
    const url = `${API_URL}get-existing-digital-ppt`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ exp_id }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExistingDigitalData(data);
        // console.log(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      <button
        type="button"
        className="btn btn-light"
        onClick={() => setShowExistingDigital(true)}
      >
        Existing digital
      </button>

      {/* --------------- existing digital ppt -------------------- */}
      {showExistingDigital && (
        <div id="existingDigital-wrapper">
          <div className="flex-container-decline-profile" style={{width: "80%", height: "70%", overflow: "hidden", padding: "0px"}}>

            <div className="flex-item-decline-profile-header" style={{flex: "2%", backgroundColor: "#365561"}}>
              <p style={{fontSize: "16px", fontWeight: "500", marginLeft: "5px", color: "white"}}>Existing digital PowerPoints of this consultant</p>
              <i 
                class="fa-solid fa-xmark" 
                style={{
                  marginRight: "5px", 
                  marginTop: "3px", 
                  color: "gray", 
                  cursor: "pointer"
                }}
                onClick={() => setShowExistingDigital(false)}
              />
            </div>


            <div className="flex-item-sugest-time-slot-calendar" style={{flex: "98%"}}>
              {existingDigitalData.length>0 ? (
                <>
                  <div style=
                    {{
                      display: "grid", 
                      gridTemplateColumns: "repeat(auto-fit, minmax(600px, 1fr))", 
                      gap: "5px", 
                      justifyContent: "center", 
                      alignItems: "center",
                      padding: "10px",
                      marginBottom: "10px"
                    }}
                  >
                    {existingDigitalData.map((item, index) => (
                      <div 
                        key={index} 
                        style={{cursor: "pointer", display: "flex", flexDirection: "row", gap: "5px", background: hoverIndex===index? "#D5EEF9" : null, padding: "5px", alignItems: "center", justifyContent: "flex-start", borderRadius: "5px", transition: "all 0.3s ease"}} 
                        onMouseEnter={() => setHoverIndex(index)}
                        onMouseLeave={() => setHoverIndex(null)}
                      >
                        <div style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start"}} ><i class="fa-regular fa-address-card" style={{color: "#365561", fontSize: "20px"}}></i></div>
                        <div>
                          <a
                            href={`/app/ExistingDigitalPPT/${
                              item.projectID
                            }/${item.expertID}/${"null"}`}
                            target="_blank"
                            rel="noreferrer"
                            onClick={() => setShowExistingDigital(false)}
                          >
                            {item.pptName}
                            <span className="digital-ppt-tooltiptext" style={{visibility: hoverIndex===index ? "visible" : "hidden", transition: "ease-in"}}>
                              {item.summ}
                            </span>
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div className="expert-ppt-digital-row">No digital powerpoint found</div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
